var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AbortablePromise_1 = __importDefault(require("./AbortablePromise"));
function abortableFetch(input, init) {
    const controller = new AbortController();
    const signal = controller.signal;
    if (init) {
        init.signal = signal;
    }
    else {
        init = {
            signal: signal
        };
    }
    const aborter = () => controller.abort();
    return new AbortablePromise_1.default(fetch(input, init), aborter);
}
exports.default = abortableFetch;
//# sourceMappingURL=abortableFetch.js.map